import { DatePicker, Form, Grid, Select, TextField } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { today } from '../../../../resources/constants';
import { legalEntityTypes } from './StepForm.constants';
import { useFormData } from './StepForm.hooks';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    const { countries, isLoadingBusinessCountries } = useFormData();

    return (
        <Form.Part>
            <TextField
                required
                name='businessInformation.companyName'
                qa='companyName'
                label={messages.companyName}
                placeholder={messages.companyNamePlaceholder}
            />

            <TextField
                name='businessInformation.tradingName'
                qa='tradingName'
                label={messages.tradingName}
                placeholder={messages.tradingNamePlaceholder}
            />

            <Select
                required
                name='businessInformation.businessCountry'
                qa='businessCountry'
                tagColor='blue20'
                label={messages.registeredCountry}
                placeholder={messages.registeredCountryPlaceholder}
                progress={isLoadingBusinessCountries}
                items={countries}
            />

            <Select
                required
                name='businessInformation.legalEntityType'
                qa='legalEntityType'
                label={messages.legalEntityName}
                placeholder={messages.legalEntityNamePlaceholder}
                items={legalEntityTypes}
            />

            <Grid gap={16} gridTemplateColumns='1fr 1fr'>
                <TextField
                    name='businessInformation.companyRegistrationNumber'
                    qa='companyRegistrationNumber'
                    label={messages.registrationNumber}
                    placeholder={messages.registrationNumberPlaceholder}
                />

                <TextField
                    required
                    name='businessInformation.vatNumber'
                    qa='vatNumber'
                    label={messages.vatNumber}
                    placeholder={messages.vatNumberPlaceholder}
                />

                <DatePicker
                    required
                    name='businessInformation.incorporationDate'
                    qa='incorporationDate'
                    label={messages.registrationDate}
                    placeholder={messages.registrationDatePlaceholder}
                    maxDate={today()}
                />
            </Grid>
        </Form.Part>
    );
});

StepForm.displayName = 'StepForm';
